<template>
  <div class="login-container">
    <div class="login-form">
      <div class="login-title">
        <img src="@/assets/logo2.png" />
        <span>海深标注平台</span>
      </div>
      <ul class="login-tab">
        <li @click="activeTab = 'login'" :class="{ active: activeTab === 'login' }">登录</li>
        <li @click="activeTab = 'register'" :class="{ active: activeTab === 'register' }">注册</li>
      </ul>

      <div v-if="activeTab === 'login'">
        <form v-on:submit.prevent="login">
          <p style="position: relative;">
            <input
              :class="{ warning: warningTab === '1' }"
              :style="{ backgroundImage: `url(${imgMobile})` }"
              v-model="data.body.mobile"
              class="input"
              type="text"
              placeholder="手机号"
              required
              maxlength="11"
            />
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '2' }"
              :style="{ backgroundImage: `url(${imgPassword})` }"
              v-model="data.body.password"
              class="input"
              type="password"
              placeholder="密码"
              required
              maxlength="20"
            />
          </p>
          <p>
            <button type="submit" class="login btn">登 录</button>
          </p>
        </form>
      </div>

      <div v-if="activeTab === 'register'">
        <form v-on:submit.prevent="signup">
          <p>
            <input
              :class="{ warning: warningTab === '3' }"
              :style="{ backgroundImage: `url(${imgUser})` }"
              v-model="data.body.userName"
              class="input"
              type="text"
              placeholder="用户名"
              required
              ref="regUserName"
              data-regex="^[0-9a-zA-Z\u4e00-\u9fa5]{2,20}$"
              data-index="3"
            />
            <span v-if="warningTab === '3'">* 2~20个字符，字母、汉字或数字均可</span>
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '4' }"
              :style="{ backgroundImage: `url(${imgMobile})` }"
              v-model="data.body.mobile"
              class="input"
              type="text"
              placeholder="11位手机号"
              required
              ref="regMobile"
              data-regex="^[1][0-9]{10}$"
              data-index="4"
              maxlength="11"
            />
            <span v-if="warningTab === '4'">* 请输入正确的手机号码</span>
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '5' }"
              :style="{ backgroundImage: `url(${imgEmail})` }"
              v-model="data.body.email"
              class="input"
              type="text"
              placeholder="邮箱"
              required
              ref="regEmail"
              data-regex="^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$"
              data-index="5"
            />
            <span v-if="warningTab === '5'">* 请输入正确的邮箱地址</span>
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '6' }"
              :style="{ backgroundImage: `url(${imgCompany})` }"
              v-model="data.body.company"
              class="input"
              maxlength="50"
              type="text"
              placeholder="公司名称"
              required
              ref="regCompany"
              data-regex="^[0-9a-zA-Z\u4e00-\u9fa5]{4,50}$"
              data-index="6"
            />
            <span v-if="warningTab === '6'">* 4~50个字符，字母、汉字或数字均可</span>
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '7' }"
              :style="{ backgroundImage: `url(${imgPassword})` }"
              v-model="data.body.password"
              class="input"
              type="password"
              placeholder="6-20位密码，区分大小写"
              required
              ref="regPwd"
              data-regex="^[0-9a-zA-Z]{6,20}$"
              data-index="7"
            />
            <span v-if="warningTab === '7'">* 6~20个字符，字母或数字均可</span>
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '8' }"
              :style="{ backgroundImage: `url(${imgConfirm})` }"
              v-model="data.body.confirmpwd"
              class="input"
              type="password"
              placeholder="确认密码"
              data-index="8"
            />
            <span v-if="warningTab === '8'">* 两次密码输入不一致，请重新输入</span>
          </p>
          <p>
            <button type="submit" class="register btn">注 册</button>
          </p>
        </form>
      </div>
    </div>
    <a class="icp-info" href="https://beian.miit.gov.cn" target="_blank">
      <span>沪ICP备20000777号-1</span>
    </a>
  </div>
</template>

<script>
import md5 from 'js-md5';
import { roleMap, passwordSalt } from '@/config';
import { dynamicRoutes } from '@/router/config';
import * as api from '@/api/api.js';

export default {
  data() {
    return {
      data: {
        body: {
          userName: null,
          password: null,
          confirmpwd: null,
          mobile: null,
          company: null,
          email: null,
        },
      },
      imgUser: require('@/assets/user.png'),
      imgMobile: require('@/assets/mobile.png'),
      imgEmail: require('@/assets/email.png'),
      imgPassword: require('@/assets/password.png'),
      imgConfirm: require('@/assets/confirm-password.png'),
      imgCompany: require('@/assets/company.png'),
      activeTab: 'login',
      warningTab: '',
    };
  },
  mounted: function() {
    if (window.localStorage.hsJwt) {
      api
        .getUserInfo()
        .then(res => {
          window.localStorage.setItem('hsJwt', res.data.token);
          this.$store.commit({ type: 'setRole', role: roleMap[res.data.user.roleId] });
          this.$store.commit({ type: 'setUserName', userName: res.data.user.userName });
          this.$store.commit({ type: 'setUserId', userId: res.data.user.id });
          this.$router.addRoutes(dynamicRoutes[roleMap[res.data.user.roleId] + 'Routes']);
          window.history.length > 2 ? this.$router.go(-1) : this.$router.push({ path: '/tasklist' });
        })
        .catch(() => {});
    }
  },
  //
  methods: {
    login() {
      this.warningTab = '';
      if (!this.data.body.mobile || !this.data.body.password) return;
      if (!this.checkInput()) return false;
      api
        .login({
          mobile: this.data.body.mobile,
          password: md5(md5(this.data.body.password) + passwordSalt),
        })
        .then(res => {
          if (res.data.token) {
            window.localStorage.setItem('hsJwt', res.data.token);
            this.$store.commit({ type: 'setRole', role: roleMap[res.data.user.roleId] });
            this.$store.commit({ type: 'setUserName', userName: res.data.user.userName });
            this.$store.commit({ type: 'setUserId', userId: res.data.user.id });
            this.$router.addRoutes(dynamicRoutes[roleMap[res.data.user.roleId] + 'Routes']);
            window.history.length > 2 ? this.$router.go(-1) : this.$router.push({ path: '/tasklist' });
          } else {
            this.$notify({
              group: 'foo',
              text: res.message,
              type: 'custom-red',
              duration: 1500,
            });
          }
        })
        .catch(() => {});
    },
    signup() {
      this.warningTab = '';
      if (this.data.body.password !== this.data.body.confirmpwd) {
        this.warningTab = '8';
        return;
      }
      if (!this.checkInput()) return;

      api
        .registerCompany({
          userName: this.data.body.userName,
          mobile: this.data.body.mobile,
          company: this.data.body.company,
          password: md5(md5(this.data.body.password) + passwordSalt),
          email: this.data.body.email,
        })
        .then(() => {
          this.$notify({
            group: 'foo',
            text: '注册成功',
            type: 'custom-blue',
            duration: 1500,
          });
          this.activeTab = 'login';
        })
        .catch(err => {
          if (err.response.data.code === 'Mobile Registed Error') {
            this.activeTab = 'login';
          }
        });
    },
    checkInput() {
      for (let el in this.$refs) {
        if (this.$refs[el]) {
          if (!this.$refs[el].value.match(this.$refs[el].dataset.regex)) {
            this.warningTab = this.$refs[el].dataset.index;
            return false;
          }
        }
      }
      return true;
    },
  },
};
</script>
<style type="text/css" scoped>
li {
  font-size: 18px;
  cursor: pointer;
}
button {
  height: 38px;
  width: 304px;
  border-radius: 4px;
  margin: 28px auto 0;
}
input {
  font-size: 14px;
  height: 38px;
  width: 304px;
  padding: 12px 12px 12px 32px;
  margin: 8px auto 16px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-position: 13px;
  background-size: 14px;
}
p {
  margin: 0;
}
p span {
  font-size: 12px;
  line-height: 12px;
  color: red;
  display: block;
  padding: 0px 68px;
  margin: auto;
  text-align: left;
}
.login-title img {
  width: 27px;
  height: 30px;
}
.login-container {
  text-align: center;
  padding: 0px;
  position: absolute;
  min-height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  background: #f5f5f5;
}
.login-form {
  box-sizing: border-box;
  margin: 160px auto 63px;
  padding: 0 0 50px;
  width: 376px;
  border-radius: 8px;
  background-color: #ffffff;
}
.login-title {
  padding: 50px 0px;
  font-size: 24px;
  color: #12335e;
}
.login-title img {
  display: inline-block;
  margin: auto 4px;
  vertical-align: middle;
}
.login-title span {
  display: inline-block;
  margin: auto 4px;
  vertical-align: middle;
}
.login-tab {
  list-style: none;
  margin: 0 0 24px;
  padding: 0px;
}
.login-tab li {
  line-height: 100%;
  display: inline-block;
  margin: 0px 20px;
  height: 100%;
  padding: 0px 42px 12px;
}
.login-tab .active {
  color: #5d89c0;
  border-bottom: 2px solid #5d89c0;
}
.warning {
  border: 1.5px solid red;
  margin-bottom: 4px;
}
.icp-info {
  display: block;
  position: absolute;
  bottom: 0px;
  width: 100%;
  min-width: 1440px;
}
</style>
